import { Component, Input, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";

@Component({
  selector: "ab-account-error-cap-reached",
  templateUrl: "./account-error-cap-reached.component.html",
})
export class AccountErrorCapReachedComponent implements OnInit {
  @Input() public user: any;

  public show: boolean;

  constructor(private accountService: AccountService) {}

  public ngOnInit() {
    this.show = false;

    this.accountService.properties().subscribe((props: any) => {
      this.show = props.alerts.error_cap_alert === true;
    });
  }
}
